var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.podeAlterarIncluir)?_c('v-btn',{attrs:{"small":"","rounded":"","color":"teal","dark":"","to":"/simular-plano-saude","disabled":_vm.meuPlano.solicitoualteracao}},[_c('v-icon',{staticClass:"mr-2",attrs:{"size":"17","color":"white"}},[_vm._v("mdi-pencil")]),_vm._v(" Trocar plano")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }